import {createContext} from 'react'
import {UseMutationResult} from '@tanstack/react-query'

interface DashboardQuery {
  'mutation': UseMutationResult;
  'agent/first-name': string | null;
  'agent/last-name': string | null;
  'agent/email-address': string | null;
  'agent/phone-number': string | null;
  'agent/phone-number-extension': string | null;
  'agent/office-phone-number': string | null;
  'agent/office-phone-number-extension': string | null;
  'agent/calendly-link': string | null;
  'agent/share-contact-info': boolean | null;
  'agent/share-phone-number-type': 'mobile' | 'office' | null;
  'agent/agency-name': string | null;
  'agent/preferred-carrier': string | null;
  'agent/top-level-agency-lddr-source': string | null;
  'agent/accepted-terms?': boolean | null;
}

export const DashboardQueryContext = createContext<DashboardQuery>(null)
